import { TRole } from '../pages/auth/interfaces';
import { menuConfigItems } from '../constants/menuConfigItems';

const {
  profile,
  vendorProducts,
  products,
  dashboard,
  orders,
  users,
  legal,
  settings,
  catalog,
  guestBlog,
  companies,
  vendorUsers,
  ordersBuyer,
  vendorCompany,
  catalogForUser,
  tenders,
  buyersTenders,
  vendorsTenders,
  addTender,
  allTenders,
  buyersDocuments,
  buyersOrders,
  usersManager,
  productDashboard,
  settingManager,
} = menuConfigItems;

const getDefaultMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [vendorsTenders, catalogForUser, profile], // deletes [blog]
  },
});

const getManagerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [productDashboard, products, orders, usersManager, settingManager, legal], // deletes [blog, settings]
  },
});

const getAdminMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [productDashboard, products, users, orders, settings, legal], // deletes [orders, tariffs, blog, chats, allTenders]
  },
});

const getVendorMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [productDashboard, ordersBuyer, vendorProducts, vendorCompany], // deletes [vendorsTenders, blog, chats, buyersDocuments]
  },
});

const getBuyerMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [catalogForUser],
  },
});

const getGuestMenu = () => ({
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [catalog, guestBlog],
  },
});

const getMenuConfig = (userRoles: TRole[] = ['ROLE_BUYER'], isAuthorized?: boolean) => {
  if (isAuthorized) {
    if (userRoles === undefined) {
      return getDefaultMenu();
    }
    if (userRoles[0] === 'ROLE_ADMIN') {
      return getAdminMenu();
    }
    if (userRoles[0] === 'ROLE_MANAGER') {
      return getManagerMenu();
    }
    if (userRoles[0] === 'ROLE_VENDOR') {
      return getVendorMenu();
    }
    if (userRoles[0] === 'ROLE_BUYER') {
      return getBuyerMenu();
    }
  } else {
    return getGuestMenu();
  }
};

export default getMenuConfig;
